import voca from "voca";
import numeral from "numeral";

const rateOptions = [
  { label: "3% (compounded daily, paid monthly)", value: 0.03 },
  { label: "5% (compounded daily, paid monthly)", value: 0.05 },
  { label: "8% (compounded daily, paid monthly)", value: 0.08 },
];

const durationInMonthOptions = [
  { label: "1 Month", value: 1 },
  { label: "2 Months", value: 2 },
  { label: "3 Months", value: 3 },
  { label: "4 Months", value: 4 },
  { label: "5 Months", value: 5 },
  { label: "6 Months", value: 6 },
  { label: "7 Months", value: 7 },
  { label: "8 Months", value: 8 },
  { label: "9 Months", value: 9 },
  { label: "10 Months", value: 10 },
  { label: "11 Months", value: 11 },
  { label: "12 Months", value: 12 },
];

const monthOptions = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];

const dayOptions = [
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
  { label: 6, value: 6 },
  { label: 7, value: 7 },
  { label: 8, value: 8 },
  { label: 9, value: 9 },
  { label: 10, value: 10 },
  { label: 11, value: 11 },
  { label: 12, value: 12 },
  { label: 13, value: 13 },
  { label: 14, value: 14 },
  { label: 15, value: 15 },
  { label: 16, value: 16 },
  { label: 17, value: 17 },
  { label: 18, value: 18 },
  { label: 19, value: 19 },
  { label: 20, value: 20 },
  { label: 21, value: 21 },
  { label: 22, value: 22 },
  { label: 23, value: 23 },
  { label: 24, value: 24 },
  { label: 25, value: 25 },
  { label: 26, value: 26 },
  { label: 27, value: 27 },
  { label: 28, value: 28 },
  { label: 29, value: 29 },
  { label: 30, value: 30 },
  { label: 31, value: 31 },
];

const depositAndPurchaseFrequencyOptions = [
  { label: "Weekly", value: "weekly", py: 52.0 },
  { label: "Bi-weekly", value: "bi-weekly", py: 26.0 },
  { label: "Monthly", value: "monthly", py: 12.0 },
  { label: "Quarterly", value: "quarterly", py: 4.0 },
  { label: "Semi-annually", value: "semi-ammualy", py: 2.0 },
];

const odcAccountOptionsFromOdcAccounts = (odcAccounts) => {
  return odcAccounts
    ? odcAccounts.map((odcAccount) => ({
        value: odcAccount.id,
        label: `${voca.capitalize(odcAccount.treatment_category)} (${numeral(
          odcAccount.balance
        ).format("$0,0.00")})`,
      }))
    : [];
};

const searchModeOptions = [
  { label: "Exact", value: "exact" },
  { label: "Fuzzy", value: "fuzzy" },
];

export {
  rateOptions,
  monthOptions,
  dayOptions,
  durationInMonthOptions,
  depositAndPurchaseFrequencyOptions,
  odcAccountOptionsFromOdcAccounts,
  searchModeOptions,
};
